var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1255_158091)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.14999 0.00976563H14.177L20.9762 7.1032V20.8842C20.9762 22.6093 19.5758 24.0098 17.8506 24.0098H6.14999C4.42483 24.0098 3.02441 22.6093 3.02441 20.8842V3.13534C3.02441 1.41019 4.42483 0.00976562 6.14999 0.00976562V0.00976563Z",
    fill: "#00A4E3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.167 0.00976562V7.04231H20.9763L14.167 0.00976562Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.0492 12.0049H8.95031C8.49367 12.0049 8.11816 12.3804 8.11816 12.837V16.7136C8.11816 17.1702 8.49364 17.5457 8.95031 17.5457H15.0492C15.5059 17.5457 15.8712 17.1702 15.8712 16.7136V12.837C15.8712 12.3804 15.5059 12.0049 15.0492 12.0049ZM10.6146 13.0501C11.1118 13.0501 11.5076 13.456 11.5076 13.9431C11.5076 14.4404 11.1118 14.8463 10.6146 14.8463C10.1173 14.8463 9.71141 14.4404 9.71141 13.9431C9.71141 13.456 10.1173 13.0501 10.6146 13.0501ZM15.3233 16.7136C15.3233 16.8658 15.2015 16.9977 15.0492 16.9977H8.95031C8.79809 16.9977 8.67631 16.8658 8.67631 16.7136V16.5512L9.78243 15.4451L10.6958 16.3584C10.8074 16.47 10.9799 16.47 11.0915 16.3584L13.385 14.0649L15.3233 16.0032V16.7136Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1255_158091"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.00976562)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcImg);
export default __webpack_public_path__ + "static/media/ic_img.af59ca59b97b1be3f72d80a150cce638.svg";
export { ForwardRef as ReactComponent };